// extracted by mini-css-extract-plugin
module.exports = {"layoutContent":"Layout_layoutContent__xegcS","wrapper":"Layout_wrapper__q801t"};